import { gql } from 'Utils/apolloClient'
import InstallmentDataFragment from './installmentDataFragment'

const installmentStateMutation = gql`
  mutation InstallmentStateUpdate($disableSendNotification: Boolean, $dueOn: ISO8601Date, $installmentId: ID!,
                                  $isEngineAdmin: Boolean!, $items: [InstallmentItemAttributes!], $name: String,
                                  $paymentSource: String, $scheduledOn: ISO8601DateTime, $state: String,
                                  $slug: ID!) {
    installmentStateUpdate(input: { campgroundId: $slug, disableSendNotification: $disableSendNotification,
                                    dueOn: $dueOn, installmentId: $installmentId, isEngineAdmin: $isEngineAdmin,
                                    items: $items, name: $name, paymentSource: $paymentSource,
                                    scheduledOn: $scheduledOn,state: $state }) {
      installment {
        ...installmentData
      }
    }
  }

  ${InstallmentDataFragment}`

export default installmentStateMutation
